<template>
  <div class="d-flex align-items-center justify-content-center">
    <Card class="w-100">
      <template #content>
        <div v-if="user" class="contents-960 w-100">
          <ShowFormItemWrapper title="名前">
            <span>{{ user.lastName }} {{ user.firstName }}</span
            ><span v-if="user.lastNameKana && user.firstNameKana"
              >({{ user.lastNameKana }} {{ user.firstNameKana }})</span
            >
          </ShowFormItemWrapper>
          <ShowFormItemEmail :email="user.email" />
          <ShowFormItemWrapper
            v-if="user.organizations.length"
            title="所属組織"
          >
            <div class="ms-3">
              <div class="ms-3">
                <ul>
                  <li
                    v-for="o in user.organizations"
                    :key="`organization-${o.id}`"
                  >
                    <span>{{ o.name }}</span>
                    <template
                      v-if="managedOrganizationPositionMap[o.id]?.length"
                    >
                      <FormLabel label="役職" without-padding />
                      <div class="ms-2">
                        <template
                          v-for="up in managedOrganizationPositionMap[o.id]"
                          :key="up.id"
                        >
                          {{ userPositionTranslater(up.positionType) }}
                        </template>
                      </div>
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </ShowFormItemWrapper>
          <ShowFormItemWrapper
            v-if="user.managedOrganizations.length"
            title="管理情報"
          >
            <div class="ms-3">
              <FormLabel label="管理組織"></FormLabel>
              <div class="ms-3">
                <ul>
                  <li
                    v-for="o in user.managedOrganizations"
                    :key="`organization-${o.id}`"
                  >
                    <span>{{ o.name }}</span>
                    <template v-if="managedOrganizationLabelMap[o.id].length">
                      <FormLabel label="権限" without-padding />
                      <div class="ms-2">
                        <template
                          v-for="ul in managedOrganizationLabelMap[o.id]"
                          :key="ul.id"
                        >
                          {{ userLabelTranslater(ul.labelType) }}
                        </template>
                      </div>
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </ShowFormItemWrapper>
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { formatNational } from "/@/modules/phonenumber";
import { formatPostcode } from "/@/modules/address";
import { useUser, useRouterUtil } from "/@/vue/composables";
import { MoreReadButton } from "/@/vue/components/Atom";
import {
  ShowFormItemEmail,
  ShowFormItemTel,
  ShowFormItemWrapper,
} from "/@/vue/components/Molecules/Form";
import { Label as FormLabel } from "/@/vue/components/Atom";
import { List as NewsList } from "/@/vue/components/Molecules/News";
import { userLabelTranslater, userPositionTranslater } from "/@/modules/user";
import { computed } from "vue";
import { UserLabel, UserPosition, UserPositionType } from "/@/types";
import Card from "primevue/card";

const { goto } = useRouterUtil();

const { getUser } = useUser();
const { data: user } = getUser({ withMemberAnnounces: true });

const menuItems = [
  { to: { name: "UsersEdit" }, label: "アカウント情報変更", visible: true },
  {
    to: { name: "UsersChangePassword" },
    label: "パスワード変更",
    visible: true,
  },
  { to: { name: "UsersTrainingsIndex" }, label: "研修", visible: false },
  // { to: { name: "UsersUnsubscribe" }, label: "退会手続き", visible: true },
];

const managedOrganizationPositionMap = computed(() => {
  let m: Record<number, UserPosition[]> = {};

  const u = user.value;

  if (!u) {
    return m;
  }

  user.value?.managedOrganizations.forEach((o) => {
    m[o.id] = u.userPositions.filter((up) => up.organizationId === o.id);
  });

  return m;
});

const managedOrganizationLabelMap = computed(() => {
  let m: Record<number, UserLabel[]> = {};

  const u = user.value;

  if (!u) {
    return m;
  }

  user.value?.managedOrganizations.forEach((o) => {
    m[o.id] = u.userLabels.filter(
      (ul) => ul.dependancyId === o.id && ul.dependancyType === "Organization"
    );
  });

  return m;
});
</script>

<style scoped lang="scss"></style>
